import React from 'react';
import style from './index.module.scss';
import cn from 'classnames';
import Transition from 'components/transition';
import UseResize from 'utils/hooks/useResize';

interface Props {
  title: string;
  advantage: { icon: string; desc: string }[];
  delay: number;
  className?: string;
}

const Advantages = (prop: Props) => {
  const { title, advantage = [], delay = 0.5, className = '' } = prop;
  const size = UseResize();

  return (
    <div className={cn(style.advantages, className)}>
      <Transition delay={delay}>
        <p className={style.title}>{title}</p>
      </Transition>

      <div className={style.items}>
        {advantage.map((item: any, index: number) => {
          return (
            <div key={index} className={style.item}>
              <div className={style.imgWrapper}>
                <Transition delay={delay}>
                  <img src={item.icon} alt="" className={style.icon} />
                </Transition>
              </div>
              <div className={style.descWrapper}>
                <Transition delay={delay}>
                  <p className={style.desc} dangerouslySetInnerHTML={{ __html: `${size.width < 768 ? item.mDesc ?? item.desc : item.desc}`.replace(/\n/g, '<br/>') }}></p>
                </Transition>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Advantages;
